export const skillsets = [
  { id: 1, title: 'HTML5', percentage: '100%' },
  { id: 2, title: 'CSS3', percentage: '80%' },
  { id: 3, title: 'Bootstrap', percentage: '80%' },
  { id: 4, title: 'Ant Design', percentage: '80%' },
  { id: 5, title: 'Javascript', percentage: '90%' },
  { id: 6, title: 'TypeScript', percentage: '80%' },
  { id: 7, title: 'React', percentage: '90%' },
  { id: 8, title: 'React-Native', percentage: '90%' },
  { id: 9, title: 'Redux', percentage: '90%' },
  { id: 10, title: 'Node', percentage: '90%' },
  { id: 11, title: 'Express', percentage: '90%' },
  { id: 12, title: 'MongoDB', percentage: '80%' },
  { id: 13, title: 'MySQL', percentage: '80%' },
  { id: 14, title: 'Firebase', percentage: '60%' },
  { id: 15, title: 'Apollo (Client & express-server)', percentage: '80%' },
  { id: 16, title: 'GraphQL', percentage: '80%' },
  { id: 17, title: 'Git', percentage: '70%' },
  { id: 18, title: 'GitHub', percentage: '80%' },
  { id: 19, title: 'Heroku', percentage: '70%' },
  { id: 20, title: 'WordPress', percentage: '90%' },
];
